import { TemplateType } from "@commons-monorepo/index";
import { useGlobalStyles } from "~/styles/context/global-styles-wrapper";
import ScrollToTopSkin1 from "./skins/skin-1/button-scroll-to-top-skin-1";
import ScrollToTopSkin2 from "./skins/skin-2/button-scroll-to-top-skin-2";

const ScrollToTop = () => {
  const { theme } = useGlobalStyles();
  return (
    <>
      {theme.template.SCROLL_TOP_BUTTON === TemplateType.SCROLL_TO_TOP_1 && (
        <ScrollToTopSkin1 />
      )}
      {theme.template.SCROLL_TOP_BUTTON === TemplateType.SCROLL_TO_TOP_2 && (
        <ScrollToTopSkin2 />
      )}
    </>
  );
};

export default ScrollToTop;
